import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../src/assets/logos/www-white-logo.png'
import _imports_1 from '../src/assets/logos/acumapify-logo.svg'


const _hoisted_1 = {
  key: 0,
  class: "max-space"
}
const _hoisted_2 = {
  key: 0,
  class: "max-space-flex"
}
const _hoisted_3 = { class: "background-secondary" }
const _hoisted_4 = { class: "max-space" }
const _hoisted_5 = {
  key: 1,
  class: "max-view-flex page-padding"
}
const _hoisted_6 = { class: "login-view__right" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "poppins tiny bold red"
}

import { onBeforeMount, ref } from 'vue';
import { confirmAccess, useUserStore } from './services/auth';
import { auth, provider } from './firebase-config';
import { signInWithPopup } from 'firebase/auth';

// --- Authentication State ---

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const userStore = useUserStore();
const userChecked = ref(false);
const authenticated = ref(false);
const adminClaim = ref(false);
const serverAdminClaim = ref(false);

// --- Login State ---
const loginError = ref('');
const isLoggingIn = ref(false);

// --- Subscribe to User Store Changes ---
userStore.$subscribe(
	async (_, state) => {
		if (state.user) {
			authenticated.value = true;
		} else {
			authenticated.value = false;
		}

		if (state.admin) {
			adminClaim.value = true;
		} else {
			adminClaim.value = false;
		}

		if (state.serverAdmin) {
			serverAdminClaim.value = true;
		} else {
			serverAdminClaim.value = false;
		}
	},
	{ flush: 'sync' }
);

// --- Methods ---
const attemptGoogleLogin = async () => {
	isLoggingIn.value = true;
	loginError.value = '';
	signInWithPopup(auth, provider)
		.then(async (result) => {
			await confirmAccess(auth); // check acumapify access and if user is an admin
			userStore.$patch({ user: result.user }); // update user store with user and admin claims if found
		})
		.catch((e) => {
			if (e.message.includes('popup-closed-by-user')) {
				loginError.value = 'NO ACCOUNT SELECTED';
			} else if (
				e.message.includes('admin-restricted-operation') ||
				e.message.includes('user-disabled') ||
				e.message.includes('unauthorized-email')
			) {
				loginError.value = 'UNRECOGNIZED ACCOUNT';
			} else {
				loginError.value = 'AN UNKNOWN ERROR OCURRED';
			}
		})
		.finally(() => {
			isLoggingIn.value = false;
		});
};

// --- Lifecycle Hooks ---
const awaitAuth = async () => {
	await auth.authStateReady(); // ensure firebase auth checks have been completed
	await confirmAccess(auth); // check access to acumapify and if user is admin
	userChecked.value = true; // allow page visibility
};

onBeforeMount(async () => {
	await awaitAuth();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (userChecked.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (authenticated.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("nav", _hoisted_3, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, "home", -1),
                    _createElementVNode("p", null, "Home", -1)
                  ]))]),
                  _: 1
                }),
                (adminClaim.value)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/inventory"
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("span", { class: "material-symbols-outlined" }, "package_2", -1),
                        _createElementVNode("p", null, "Inventory", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, { to: "/webquotes" }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, "price_check", -1),
                    _createElementVNode("p", null, "Web Quotes", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/weborders" }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, "shopping_cart", -1),
                    _createElementVNode("p", null, "Web Orders", -1)
                  ]))]),
                  _: 1
                }),
                (serverAdminClaim.value)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: "/users"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("span", { class: "material-symbols-outlined" }, "group", -1),
                        _createElementVNode("p", null, "Users", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_view)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"login-view__left\"><img src=\"" + _imports_0 + "\" alt=\"www-white-logo.png\" style=\"width:125px;height:125px;\"><div class=\"slogan\"><h1 class=\"company-name\">MINTECH</h1><h2 class=\"company-slogan\">Wear What Works.</h2></div></div>", 1)),
              _createElementVNode("div", _hoisted_6, [
                _cache[5] || (_cache[5] = _createElementVNode("img", {
                  src: _imports_1,
                  alt: "logo",
                  style: {"width":"100px","height":"100px"}
                }, null, -1)),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "fira semi-large" }, "Welcome to Acumapify!", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "login-with-google-btn",
                  onClick: attemptGoogleLogin,
                  disabled: isLoggingIn.value
                }, "Sign in with Google", 8, _hoisted_7),
                (loginError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(loginError.value), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]))
    : _createCommentVNode("", true)
}
}

})